import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { numToApparatus, teamBrand } from '../../utilities/conversions';
import { useTeamRotations } from '../../utilities/scoring';
import * as Icons from '../helpers/icons';
import { TeamBannerSelector } from './teambanner';
import { useRotations, useSortedLineups } from './hooks';

function ScoreSheetHeader({ teamSide, index }) {
  const teamId = useSelector((state) => state.producer[teamSide].teamId);
  const lineupId = useSelector((state) => state.producer[teamSide].lineupId);
  const gender = useSelector((state) => state.session.gender);
  const sessionId = useSelector((state) => state.session.id);
  const lineups = useSortedLineups(sessionId);
  const rotations = Object.values(useRotations(sessionId));
  const rotationList = useTeamRotations();

  const teams = lineups.map((l) => {
    const { name } = teamBrand(l.team);
    return {
      ...l.team,
      lineupId: l.id,
      displayName: l.forceTitle || l.individuals ? l.title : name,
    };
  });

  const team = teams.find((t) => t.lineupId === lineupId);
  const { displayName } = team || {};
  const { logo } = teamBrand(team);
  const apparatusAbbv = numToApparatus(index, true, gender);
  const apparatusName = numToApparatus(index, false, gender);
  let rotationConfig = rotationList(rotations, teamId, lineupId);
  if (!rotationConfig?.configured) {
    rotationConfig = rotationList(rotations, teamId, null);
  }
  const scheduledRotation =
    rotationConfig?.byApparatus?.[apparatusAbbv] ??
    rotationConfig?.byApparatus?.[apparatusName];
  const apparatusLabel = scheduledRotation
    ? `${apparatusName} | R${scheduledRotation}`
    : apparatusName;

  return (
    <div className="teamBanner">
      <Row style={{ height: '100%' }}>
        <Col xs={10} className="vCenter">
          <TeamBannerSelector
            name={`${displayName}`}
            teams={teams}
            selected={teamId}
            side={teamSide}
            lineupId={lineupId}
            logo={logo}
            scoresheet={true}
          ></TeamBannerSelector>
        </Col>
        <Col
          className="vCenter icon apparatusHeader"
          xs={2}
          style={{ height: '4rem', margin: 'auto' }}
        >
          <div
            className={[
              'apparatusHeaderContent',
              apparatusAbbv ? `apparatus-${apparatusAbbv.toLowerCase()}` : null,
            ].join(' ')}
          >
            <span className="apparatusHeaderLabel">{apparatusLabel}</span>
            {Icons?.[`${apparatusAbbv}noText`]}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ScoreSheetHeader;
